<template>
  <div>
    <div v-if="products.length > 1">
      <div v-for="(item, index) in products" :key="index" class="item-list f-left w-100pct pd-vtc-10px al-center dp-flex al-it-center">
        <div class="w-30pct f-left">
          <img :src="item.image" alt="" width="60%">
        </div>
        <div class="w-40pct f-left t-al-left">
          <span><b>{{ item.name }}</b></span> <br>
          <span  v-if="!item.option.includes('default')">{{ item.option }} <br> </span>
          <span>In Stock {{ item.remain }}</span> <br>
          <span>ราคา ฿ {{ item.price | showFullPriceFormat() }} </span> <br>
        </div>
        <div class="w-30pct f-left">
          <svg-filler class="cs-pointer" @click="addItem(item)" path="/static/svg/basket.svg" :fill="'#1b0000'" width="30px" height="30px" />
        </div>
      </div>
    </div>
    <div v-else-if="products.length === 1">
      <img :src="products[0].image" alt="" class="w-180px">
      <div class="f-s-16px f-w-bold">
        <span>{{products[0].name}}</span>
      </div>
      <div class="f-s-16px pd-16px">
        <p>
          {{products[0].option1}} <br>
          <span v-if="products[0].option2 !== ' : '">{{products[0].option2}} <br></span>
          stock : {{products[0].remain}} <br>
          <span>Price ฿ {{ products[0].price | showFullPriceFormat() }}</span> <br>
        </p>
      </div>
      <div class="dp-flex jtf-ct-center">
        <div class="minus-item cs-pointer" :style="`background-color: ${mainColor};`" @click="amountItem--">
          -
        </div>
        <div class="item-amout-box pd-t-6px">
          {{amountItem}}
        </div>
        <div class="add-item cs-pointer" :style="`background-color: ${mainColor};`"  @click="amountItem++">
          +
        </div>
      </div>
      <div class="pd-vtc-16px">
        <div class="add-item-tab f-s-24px f-w-bold pd-8px cl-white cs-pointer" @click="addItemData(products[0])">
          Add To Cart
        </div>
      </div>
    </div>
    <div v-else class="mg-auto pd-t-100px">
      <svg-filler path="/static/svg/QR icon big.svg" class="" :fill="'#f2f2f2'" width="220px" height="220px"/>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'list-product',
  props: ['products', 'searchKey'],
  data () {
    return {
      amountItem: 1
    }
  },
  methods: {
    ...mapActions([
      'addItem'
    ]),
    addItemData (item) {
      for (let i = 0; i < this.amountItem; i++) {
        this.addItem(item)
      }
    }
  },
  watch: {
    amountItem (val) {
      if (val <= 0) {
        this.amountItem = 1
      }
    }
  }
}
</script>

<style scoped>
.add-item-tab {
  width: 100%;
  height: 48px;
  background-color: #27cf5a;
}
.item-list {
  border-bottom: 1px solid;
  border-color: #cfcfcf;
}
.item-amout-box {
  width: 88px;
  height: 36px;
  border: solid 1px #1b0000;
  font-size: 18px;
  font-weight: bold;
}
.add-item {
  font-size: 24px;
  font-weight: bold;
  color: #ffffff;
  width: 36px;
  height: 36px;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  border: solid 1px #1b0000;
}
.minus-item {
  font-size: 24px;
  font-weight: bold;
  color: #ffffff;
  width: 36px;
  height: 36px;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  border: solid 1px #1b0000;
}
</style>



// WEBPACK FOOTER //
// src/views/home/ListProduct.vue